import type { ReactElement } from "react";
import type React from "react";
import { SWReactIcons } from "@similarweb/icons";
import type { IconName, IconSize } from "@similarweb/icons";
import { AccordionHeadWrapper, TitleContainer, Title } from "app/components/Accordion/AccordionHeadStyled";

interface IAccordionHeadContent {
    isAccordionOpen: boolean;
    title: string;
    titleIconName?: IconName;
    titleIconColor?: string;
    titleIconSize?: IconSize;
    headerContent?: ReactElement;
}

export const AccordionHead: React.FC<IAccordionHeadContent> = ({
    isAccordionOpen,
    title,
    titleIconName,
    titleIconColor,
    titleIconSize = "md",
    headerContent,
}) => {
    return (
        <AccordionHeadWrapper>
            <TitleContainer>
                {titleIconName ? (
                    <SWReactIcons
                        iconName={titleIconName}
                        size={titleIconSize}
                        iconColor={titleIconColor}
                    />
                ) : null}
                <Title isAccordionOpen={isAccordionOpen}>{title}</Title>
            </TitleContainer>
            {headerContent}
        </AccordionHeadWrapper>
    );
};
